import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VRow,{staticClass:"text-h4 text-right"},[_c(VCol,{staticClass:"grey--text"},[_vm._v(" Est. total ")]),_c(VCol,{attrs:{"cols":"auto"},domProps:{"textContent":_vm._s(_vm.getTotalPrice({currency: true, tbd: true}))}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }